import { render, staticRenderFns } from "./SubmitDemo.vue?vue&type=template&id=f4a57cb6&scoped=true"
import script from "./SubmitDemo.vue?vue&type=script&lang=js"
export * from "./SubmitDemo.vue?vue&type=script&lang=js"
import style0 from "./SubmitDemo.vue?vue&type=style&index=0&id=f4a57cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a57cb6",
  null
  
)

export default component.exports